
















import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    getProgram,
    postProgram,
    patchProgram,
    getCustomers,
    getCompanies,
} from '../api/api';
import Program from '../models/Program';
import Company from '../models/Company';
import moment from 'moment';
import get from 'lodash/get';
import countries from '@/data/countries';
import taxSystems from '@/data/taxSystems';
import { BACKEND_URL } from '@/helpers/constants';
import router from '@/router';
import AuthModule from '../store/AuthModule';
import { getStatusItems } from '@/data/programStateStatus';
import FileCurrent from '@/models/FileCurrent';

let program: Program | null = null;

async function getProgramForRouter(programID: string) {
    try {
        const { data } = await getProgram(+programID);
        return data;
    } catch (error) {
        // console.warn(error, get(error, 'response.data.message'));
        return null;
    }
}

function getProgramName(value: Program | null) {
    if (value) {
        return value.name;
    }
    return null;
}



@Component({
    beforeRouteEnter: async (to, from, next) => {
        const { route } = router.resolve({
            name: 'programs',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        if (to.params.id) {
            program = await getProgramForRouter(to.params.id);

            if (program == null) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Programme introuvable.`,
                });

                next({
                    name: 'programs',
                });
                return;
            } else {
                to.meta.breadcrumb[2].title = getProgramName(program);
            }
        }

        next();
    },
    beforeRouteUpdate: async (to, from, next) => {
        if (to.params.id) {
            program = await getProgramForRouter(to.params.id);
            to.meta.breadcrumb[2].title = getProgramName(program);
        }

        next();
    },
    components: {
        Forms,
    },
})
export default class ProgramForm extends Vue {
    error: string | null = null;
    errors: any = {};
    title: string = '';
    program: Program | null = program;
    companiesItems: Array<{ text: string; value: number }> = [];
    defaultImages: any | null = null;
    loading: boolean = false;

    mounted() {
        // Copy the Vuesax --vs-primary CSS variable (comma-separated RGB) onto this
        // component's root element so that all /deep/ rgba(var(--vs-primary), X) rules
        // use the app's actual live primary colour instead of a hardcoded build-time value.
        const raw = getComputedStyle(document.documentElement)
            .getPropertyValue('--vs-primary')
            .trim();
        if (raw) {
            (this.$el as HTMLElement).style.setProperty('--vs-primary', raw);
        }
    }
    get items() {
        function isManageable() {
            if(program && program.tax_system) {
                if (program.tax_system.includes('LMNP VEFA Divers') ||
                    program.tax_system.includes('LMNP Étudiant') ||
                    program.tax_system.includes('LMNP Senior') ||
                    program.tax_system.includes('LMNP Tourisme') ||
                    program.tax_system.includes('LMNP EHPAD') ||
                    program.tax_system.includes('LMNP Colocation') ||
                    program.tax_system.includes('LMNP Coliving') ||
                    program.tax_system.includes('LMNP CRT') ||
                    program.tax_system.includes('CIIC Corse') ||
                    program.tax_system.includes('Revente LMNP') ||
                    program.tax_system.includes('Revente LMNP Étudiant') ||
                    program.tax_system.includes('Revente LMNP Sénior') ||
                    program.tax_system.includes('Revente LMNP Rés') ||
                    program.tax_system.includes('Revente LMNP EHPAD') ||
                    program.tax_system.includes('Revente LMNP Tourisme') ||
                    program.tax_system.includes('Revente fin défiscalisation')) {
                    return true;
                }
            }
            return false;
        }

        return [
            // ── Informations générales (default / no section) ──────────────────
            {
                name: 'images',
                label: 'Image principale au format 16:9 ( 1920 x 1080 )',
                type: 'image_as_array',
                slug: 'primaryPerspective',
                accept: 'image/*',
            },
            {
                name: 'name',
                label: 'Nom du programme *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'tax_system',
                label: 'Fiscalité *',
                type: 'select',
                errorMessage: 'La fiscalité est requise',
                required: true,
                multiple: true,
                items: taxSystems,
            },
            {
                name: 'promoter',
                label: 'Nom du Vendeur/Promoteur *',
                type: 'select',
                items: this.companiesItems,
                required: true,
            },
            {
                name: 'manager_operator',
                label: 'Gestionnaire/Exploitant',
                type: 'text',
                hidden: !isManageable(),
            },

            // ── Calendrier ─────────────────────────────────────────────────────
            {
                name: 'date_building_permit_purged',
                label: 'Date de PC purgé',
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'date_actability',
                label: "Date d'actabilité",
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'date_start_building',
                label: 'Date de démarrage travaux',
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'date_end_building',
                label: 'DAT : Date Achèvement Travaux',
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'date_delivery',
                label: 'Date de livraison *',
                type: 'date',
                required: true,
                section: 'Calendrier',
            },
            {
                name: 'date_fin_bail',
                label: 'Date de fin de bail',
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'date_debut_bail',
                label: 'Date de début de bail',
                type: 'date',
                section: 'Calendrier',
            },
            {
                name: 'bail_duration',
                label: 'Durée du bail (en années)',
                type: 'number',
                min: 0,
                section: 'Calendrier',
            },

            // ── Finances ───────────────────────────────────────────────────────
            {
                name: 'taxe_fonciere',
                label: 'Taxe Foncière : (en € TTC /an)',
                type: 'number',
                min: 0,
                section: 'Finances',
            },
            {
                name: 'charges_copro',
                label: 'Charges Copro annuelles : (en € TTC /an)',
                type: 'number',
                min: 0,
                section: 'Finances',
            },
            {
                name: 'nb_total_lots',
                label: 'Nb Total lots',
                type: 'number',
                min: 0,
                max: 1000,
                section: 'Finances',
            },
            {
                name: 'profitability_program_gtie',
                label: 'Renta. Prog. Gtie (en %)',
                type: 'number',
                min: 0,
                max: 100,
                step: 0.01,
                isFloat: true,
                section: 'Finances',
                hidden:
                    this.defaultValue.tax_system.find((tax_system: string) =>
                        tax_system.includes('LMNP')
                    ) === undefined,
            },
            {
                name: 'duty_free_fee',
                label: 'Honoraires (%)',
                type: 'number',
                section: 'Finances',
                hidden: this.program
                    ? this.program.promoter.is_multi_fee !== 'no'
                    : true,
            },
            {
                name: 'valeur_nue_pro_percent',
                label: 'Valeur Nue Pro (%)',
                type: 'number',
                section: 'Finances',
            },
            {
                name: 'duree_usufruit',
                label: "Durée d'usufruit (années)",
                type: 'number',
                section: 'Finances',
            },

            // ── Description & médias ───────────────────────────────────────────
            {
                name: 'description',
                label: 'Présentation du programme Selon Promoteur *',
                type: 'textarea',
                required: true,
                section: 'Description & Médias',
            },
            {
                name: 'url',
                label: 'Lien vers Visite 3D / Vidéo Progs.',
                type: 'text',
                section: 'Description & Médias',
            },
            {
                name: 'dff_comments',
                label: 'Infos Progs et Hono',
                type: 'textarea',
                section: 'Description & Médias',
            },

            // ── Adresse ────────────────────────────────────────────────────────
            {
                name: 'address',
                type: 'address',
                section: 'Adresse',
                fields: {
                    street: {
                        label: 'Adresse programme *',
                        name: 'street',
                        required: true,
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal *',
                        name: 'postal_code',
                        required: true,
                    },
                    city: {
                        label: 'Ville *',
                        name: 'city',
                        required: true,
                    },
                    country: {
                        label: 'Pays *',
                        name: 'country',
                        required: true,
                    },
                    latitude: {
                        label: 'Latitude',
                        name: 'latitude',
                        required: false,
                    },
                    longitude: {
                        label: 'Longitude',
                        name: 'longitude',
                        required: false,
                    },
                },
            },

            // ── Boost & Avantages ──────────────────────────────────────────────
            {
                name: 'boost_due_date_prescriber',
                label: 'Date Limite boost hono.',
                type: 'date',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },
            {
                name: 'boost_due_date_customer',
                label: 'Date Limite avant. client',
                type: 'date',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },
            {
                name: 'is_boost_prescriber',
                label: 'Boost hono.',
                type: 'switch',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },
            {
                name: 'is_boost_customer',
                label: 'Avant. client',
                type: 'switch',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },
            {
                name: 'boost_comment_prescriber',
                label: 'Commentaire boost hono.',
                type: 'textarea',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },
            {
                name: 'boost_comment_customer',
                label: 'Commentaire avant. client',
                type: 'textarea',
                section: 'Boost & Avantages',
                hidden: this.program
                    ? this.program.promoter.multi_boost !== 'no'
                    : true,
            },

            // ── Mandat ─────────────────────────────────────────────────────────
            {
                name: 'mandat_num_mandat',
                label: 'Numéro de mandat',
                type: 'number',
                section: 'Mandat',
                hidden: !this.isMultiMandat,
            },
            {
                name: 'mandat_mandat',
                label: 'Pièce jointe mandat',
                type: 'custom-file',
                current: 'mandat_file',
                section: 'Mandat',
                hidden: !this.isMultiMandat,
                fields: {
                    name: 'mandat_mandat_filename',
                    content: 'mandat_mandat_file',
                },
            },
            {
                name: 'mandat_date_due',
                label: "Date d'échéance du mandat",
                type: 'date',
                section: 'Mandat',
                hidden: !this.isMultiMandat,
            },

            // ── Statut ─────────────────────────────────────────────────────────
            {
                name: 'status',
                label: 'Statut',
                type: 'select',
                section: 'Statut',
                hidden: this.type === 'add',
                items: this.statusItems,
            },
        ];
    }
    value: any | null = null;
    defaultValue: any = {
        images: [],
        name: null,
        description: null,
        promoter: null,
        planned_delivery_at: null,
        real_delivery_at: null,
        building_start_at: null,
        tax_system: [],
        url: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
            country: null,
            latitude: null,
            longitude: null,
        },
        date_building_permit_purged: null,
        date_actability: null,
        date_start_building: null,
        date_end_building: null,
        date_delivery: null,
        date_fin_bail: null,
        date_debut_bail: null,
        bail_duration: null,
        taxe_fonciere: null,
        charges_copro: null,
        nb_total_lots: null,
        profitability_program_gtie: 0,
        duty_free_fee: null,
        dff_comments: null,
        valeur_nue_pro_percent: null,
        duree_usufruit: null,
        boost_due_date_prescriber: null,
        boost_due_date_customer: null,
        boost_comment_prescriber: null,
        boost_comment_customer: null,
        is_boost_prescriber: null,
        is_boost_customer: null,
        mandat_num_mandat: null,
        mandat_date_due: null,
        status: 'data_processing',
        manager_operator:null,
    };


    get type(): 'edit' | 'add' {
        return this.$route.name === 'addProgram' ? 'add' : 'edit';
    }

    get statusItems() {
        if (this.program) {
            return getStatusItems(this.program.status, AuthModule.roles);
        }
        return [];
    }

    get isMultiMandat() {
        return this.program
            ? this.program.promoter.is_multi_mandat === 'no'
            : false;
    }

    getValue(value: any) {
        this.value = value;
    }

    async created(): Promise<void> {
        this.loading = true;
        const companiesData = await getCompanies();
        const companies = companiesData.data;
        companies.forEach((item: Company) => {
            this.companiesItems.push({
                value: item.id || 0,
                text: item.name,
            });
        });

        this.title =
            this.type === 'add'
                ? 'Ajouter un programme'
                : 'Editer le programme';
        if (this.type === 'edit' && this.program) {
            this.defaultImages =
                this.program.primary_perspective &&
                `${BACKEND_URL}${this.program.primary_perspective.url}${
                    this.program.primary_perspective.name
                }.${this.program.primary_perspective.extension}`;

            this.defaultValue.description = this.program.description || null;
            this.defaultValue.promoter = this.program.promoter
                ? this.program.promoter.id
                : null;
            this.defaultValue.date_building_permit_purged =
                (this.program.date_building_permit_purged &&
                    moment(this.program.date_building_permit_purged)) ||
                null;
            this.defaultValue.date_actability =
                (this.program.date_actability &&
                    moment(this.program.date_actability)) ||
                null;
            this.defaultValue.date_start_building =
                (this.program.date_start_building &&
                    moment(this.program.date_start_building)) ||
                null;
            this.defaultValue.date_end_building =
                (this.program.date_end_building &&
                    moment(this.program.date_end_building)) ||
                null;
            this.defaultValue.date_delivery =
                (this.program.date_delivery &&
                    moment(this.program.date_delivery)) ||
                null;
            this.defaultValue.date_fin_bail =
                (this.program.date_fin_bail &&
                    moment(this.program.date_fin_bail)) ||
                null;
            this.defaultValue.date_debut_bail =
                (this.program.date_debut_bail &&
                    moment(this.program.date_debut_bail)) ||
                null;
            this.defaultValue.name = this.program.name || null;
            this.defaultValue.taxe_fonciere = this.program.taxe_fonciere || null;
            this.defaultValue.charges_copro = this.program.charges_copro || null;
            this.defaultValue.tax_system = this.program.tax_system || [];
            this.defaultValue.url = this.program.url || null;
            this.defaultValue.address.street =
                (this.program.address && this.program.address.street) || null;
            this.defaultValue.address.street2 =
                (this.program.address && this.program.address.street2) || null;
            this.defaultValue.address.postal_code =
                (this.program.address && this.program.address.postal_code) ||
                null;
            this.defaultValue.address.city =
                (this.program.address && this.program.address.city) || null;
          this.defaultValue.address.country =
              (this.program.address && this.program.address.country) || null;
            this.defaultValue.address.latitude =
                (this.program.address && this.program.address.latitude) || null;
            this.defaultValue.address.longitude =
                (this.program.address && this.program.address.longitude) ||
                null;
            this.defaultValue.nb_total_lots = this.program.nb_total_lots || 1;
            this.defaultValue.profitability_program_gtie =
                this.program.profitability_program_gtie || 0;
            this.defaultValue.bail_duration = this.program.bail_duration || null;
            this.defaultValue.duty_free_fee =
                this.program.duty_free_fee || null;
            this.defaultValue.dff_comments = this.program.dff_comments || null;
            this.defaultValue.valeur_nue_pro_percent = this.program.valeur_nue_pro_percent || null;
            this.defaultValue.duree_usufruit = this.program.duree_usufruit || null;
            this.defaultValue.boost_due_date_prescriber =
                (this.program.boost_due_date_prescriber &&
                    moment(this.program.boost_due_date_prescriber)) ||
                null;
            this.defaultValue.boost_due_date_customer =
                (this.program.boost_due_date_customer &&
                    moment(this.program.boost_due_date_customer)) ||
                null;
            this.defaultValue.boost_comment_prescriber =
                this.program.boost_comment_prescriber || null;
            this.defaultValue.boost_comment_customer =
                this.program.boost_comment_customer || null;
            this.defaultValue.is_boost_prescriber =
                this.program.is_boost_prescriber || null;
            this.defaultValue.is_boost_customer =
                this.program.is_boost_customer || null;
            this.defaultValue.status = this.program.status || 'data_processing';
            this.defaultValue.mandat_num_mandat = this.program.mandat
                ? this.program.mandat.num_mandat
                : null;
            this.defaultValue.mandat_date_due = this.program.mandat
                ? moment(this.program.mandat.date_due)
                : null;

            if (this.program.mandat && this.program.mandat.mandat_file) {
                const current: FileCurrent = {
                    name: `${this.program.mandat.mandat_file.name}.${
                        this.program.mandat.mandat_file.extension
                    }`,
                    downloadMandat: this.program,
                };

                this.defaultValue.mandat_file = current;
                this.defaultValue.manager_operator = this.program.manager_operator;
            }
        }
        this.loading = false;
    }

    async submit(form: any) {
        const hasLmnpTaxSystem =
            this.defaultValue.tax_system.find((tax_system: string) =>
                tax_system.includes('LMNP')
            ) === undefined;

        this.loading = true;
        const newProgram: Program = {
            images: form.images,
            name: form.name,
            description: form.description,
            tax_system: form.tax_system,
            promoter: form.promoter,
            date_building_permit_purged: form.date_building_permit_purged,
            date_actability: form.date_actability,
            date_start_building: form.date_start_building,
            date_end_building: form.date_end_building,
            date_delivery: form.date_delivery,
            date_fin_bail: form.date_fin_bail,
            date_debut_bail: form.date_debut_bail,
            bail_duration: form.bail_duration,
            taxe_fonciere: form.taxe_fonciere,
            charges_copro: form.charges_copro,
            url: form.url,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
                country: form.address.country,
                latitude: form.address.latitude,
                longitude: form.address.longitude,
            },
            dff_comments: form.dff_comments,
            valeur_nue_pro_percent: form.valeur_nue_pro_percent,
            duree_usufruit: form.duree_usufruit,
            boost_due_date_prescriber:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.boost_due_date_prescriber
                    : '',
            boost_due_date_customer:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.boost_due_date_customer
                    : '',
            boost_comment_prescriber:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.boost_comment_prescriber
                    : '',
            boost_comment_customer:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.boost_comment_customer
                    : '',
            is_boost_prescriber:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.is_boost_prescriber
                    : '',
            is_boost_customer:
                this.program && this.program.promoter.multi_boost === 'no'
                    ? form.is_boost_customer
                    : '',
            nb_total_lots: form.nb_total_lots,
            profitability_program_gtie:
                hasLmnpTaxSystem || isNaN(form.profitability_program_gtie)
                    ? ''
                    : parseFloat(form.profitability_program_gtie).toFixed(2),
            duty_free_fee:
                this.program && this.program.promoter.is_multi_fee === 'no'
                    ? form.duty_free_fee
                    : '',
            status: form.status,
            manager_operator: form.manager_operator,
            mandat:
                !this.program || this.program.promoter.is_multi_mandat !== 'no'
                    ? undefined
                    : {
                          num_mandat: form.mandat_num_mandat,
                          date_due: form.mandat_date_due,
                          mandat_file: form.mandat_mandat_file,
                      },
        };

        const $vs = (this as any).$vs;
try {
            let program = null;
            if (this.type === 'add') {
                // console.log('Payload being sent to backend:', JSON.stringify(newProgram, null, 2));

                const resp = await postProgram(newProgram);
                program = resp.data;
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création du programme réussie`,
                });
            } else {
                const resp = await patchProgram(
                    +this.$route.params.id,
                    newProgram
                );
                program = resp.data;
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification du programme réussie`,
                });
            }

            if (form.targetView === 'show') {
                this.$router.push({
                    name: 'showProgram',
                    params: {
                        programID: program.id,
                    } as any,
                });
            } else {
                this.$router.push({ name: 'programs' });
            }
        } catch (error) {
            // console.log('Full error object:', error);
            // console.log('Error response:', error.response);
            // console.log('Error data:', error.response ? error.response.data : 'Aucune donnée d\'erreur');
            
            this.errors = get(error, 'response.data.errors.children', {});

            const message = get(
                error,
                'response.data.errors.errors[0]',
                'Erreur lors de la soumission du formulaire'
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.loading = false;
        }
    }
}
